<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Phân hệ Trường học: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-col :span="24">
          <div v-for="(category) in this.homeMenu" :key="category.key">
            <div class="line line-1 pt-2" @click.stop="clickLevel(category)">
              <input disabled="true" type="text" placeholder="Hệ đào tạo" v-model="category.name">
              <i class="fas fa-check-square" style="color: #000" v-if="category.checked == true"></i>
            </div>
            <div style="padding-left: 80px;" v-if="category.checked == true">
              <div v-for="(set) in category.options" :key="set.key">
                <div class="line line-2" @click.stop="clickLevel(set)">
                  <input disabled="true" type="text" placeholder="Khoa" v-model="set.name">
                  <i class="fas fa-check-square" style="color: #000" v-if="set.checked == true"></i>
                </div>
                <div style="padding-left: 80px;" v-if="set.checked == true">
                  <div v-for="(color) in set.options" :key="color.key">
                    <div class="line" @click.stop="clickLevel(color)">
                      <input disabled="true" type="text" placeholder="Chuyên ngành" v-model="color.name">
                      <i class="fas fa-check-square" style="color: #000" v-if="color.checked == true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModel()">Cập nhật</el-button>
        <el-button
          size="small"
          class="btn-back"
          @click="backModel">Trở về
        </el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CategoryBlogUpdate',
  metaInfo () {
    return {
      title: 'Trường học'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        name: '',
        parant_id: '',
        priority: '',
        city_code: '',
        district_code: '',
        ward_code: '',
        status: false
      },
      homeMenu: []
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.fetchModelHomeMenu()
  },
  methods: {
    clickLevel (item) {
      item.checked = !item.checked
      this.canSubmit = false
      setTimeout(() => {
        this.canSubmit = true
      }, 50)
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'schools-index', text: 'Trường học' },
        { name: 'schools-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'schools-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('schools/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          case 422:
            this.$router.push({name: 'home-index'})
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.post('schools/get-level-facult-specialized/' + this.$route.params.id).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.homeMenu = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      // console.log(JSON.stringify(this.homeMenu))
      let data = {
        'level_facult_specialized': this.homeMenu
      }
      axios.post('schools/update-level-facult-specialized/' + this.$route.params.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'schools-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  margin-top: 10px;
  margin-bottom: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.line:hover {
  background-color: #007a36;
}
.line-1 {
  background-color: #eaeeaa;
  padding: 5px 5px;
}
.line-2 {
  background-color: #ccc;
  padding: 5px 5px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/schools/Config.vue